import React, {FC} from 'react';
import {Controller, useWatch} from "react-hook-form";
import Checkbox from "../../../../../components/Checkbox";
import styled from "styled-components";
import {TextArea} from "../../../../../components/TextArea";
import {Control} from "react-hook-form/dist/types/form";

interface Props {
  setChangedEmployee: (val: boolean) => void;
  control: Control;
}

const RestaurantEmployeeFields:FC<Props> = ({setChangedEmployee, control}) => {
  const smsValue = useWatch({
    control,
    name: "to_candidate.restaurant_employee.sms"
  });

  const emailValue = useWatch({
    control,
    name: "to_candidate.restaurant_employee.email"
  });

  const changesHandler = () => {
    setChangedEmployee(true);
  }

  return (
    <>
      <FieldWrapper>
        <CheckboxesWrapper>
          <Controller
            render={({field, fieldState}) =>
              <Checkbox
                {...field}
                {...fieldState}
                label="sms"
                onChange={(value) => {
                  field.onChange(value);
                  changesHandler();
                }}
                ref={null}
              />
            }
            name="to_candidate.restaurant_employee.sms"
            control={control}
          />
          <Controller
            render={({field, fieldState}) =>
              <Checkbox
                {...field}
                {...fieldState}
                label="Email"
                onChange={(value) => {
                  field.onChange(value);
                  changesHandler();
                }}
                ref={null}
              />
            }
            name="to_candidate.restaurant_employee.email"
            control={control}
          />
        </CheckboxesWrapper>
      </FieldWrapper>
      <FieldWrapper>
        <Controller
          render={({field, fieldState}) =>
            <TextArea
              {...field}
              {...fieldState}
              placeholder="Текст сообщения (шаблон)"
              disabled={!smsValue && !emailValue}
              onChange={(value) => {
                field.onChange(value);
                changesHandler();
              }}
              ref={null}
            />
          }
          name="to_candidate.restaurant_employee.message"
          control={control}
        />
      </FieldWrapper>
    </>
  );
};

const FieldWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 15px;
  }
`;

const CheckboxesWrapper = styled.div`
  display: flex;
  gap: 15px;
`;

export default RestaurantEmployeeFields;